// Api
import * as apiAuth from 'api/auth'
import * as apiOtp from 'api/back-office/otp'
import * as apiWebpage from 'api/webpage'
import * as apiMaster from 'api/back-office/master'
import * as apiPersonalData from 'api/back-office/personal-data'
import * as apiUser from 'api/back-office/user'
import * as apiQa from 'api/back-office/qa'
import * as apiUserAccess from 'api/back-office/user-access'
import * as apiContentManagement from 'api/back-office/content-management'
import * as apiSetSelfAssessmentForm from 'api/back-office/set-self-assessment-form'
import * as apiAssessment from 'api/back-office/assessment'

export class Environment {
  // Auth
  authApi: apiAuth.AuthApi

  // OTP
  otpApi: apiOtp.OtpApi

  // Webpage
  homeWebpageApi: apiWebpage.HomeWebpageApi
  aboutUsWebpageApi: apiWebpage.AboutUsWebpageApi
  assessorWebpageApi: apiWebpage.AssessorWebpageApi
  tukWebpageApi: apiWebpage.TukWebpageApi
  galleryWebpageApi: apiWebpage.GalleryWebpageApi
  contactUsWebpageApi: apiWebpage.ContactUsWebpageApi
  newsWebpageApi: apiWebpage.NewsWebpageApi

  // Webpage - Certification
  certificationWebpageApi: apiWebpage.CertificationWebpageApi

  // Webpage - Certification - Registration
  certificationWebpageProcessDateApi: apiWebpage.CertificationWebpageProcessDateApi
  certificationWebpagePersonalDataApi: apiWebpage.CertificationWebpagePersonalDataApi
  certificationWebpageGeneralProofApi: apiWebpage.CertificationWebpageGeneralProofApi
  certificationWebpageRelevantProofApi: apiWebpage.CertificationWebpageRelevantProofApi
  certificationWebpageSupportDocumentApi: apiWebpage.CertificationWebpageSupportDocumentApi
  certificationWebpagePurposeOfAssessmentApi: apiWebpage.CertificationWebpagePurposeOfAssessmentApi
  certificationWebpageSelfAssessmentApi: apiWebpage.CertificationSelfAssessmentWebpageApi
  certificationWebpageFinalApi: apiWebpage.CertificationWebpageFinalApi

  // Master
  masterBranchApi: apiMaster.BranchApi
  masterCompanyApi: apiMaster.CompanyApi
  masterDocumentDetailApi: apiMaster.DocumentDetailApi
  masterDocumentProofApi: apiMaster.DocumentProofApi
  masterRoleApi: apiMaster.RoleApi
  masterFieldApi: apiMaster.FieldApi
  masterCertificationSchemaApi: apiMaster.CertificationSchemaApi

  // Personal Data
  profileApi: apiPersonalData.ProfileApi
  myDocumentApi: apiPersonalData.MyDocumentApi
  additionalQuestionApi: apiPersonalData.AdditionalQuestionAPI

  // User Management
  userApi: apiUser.UserApi

  // User Access
  userAccessApi: apiUserAccess.UserAccessApi

  // QnA
  qaApi: apiQa.QaApi

  // Content Management - Home
  homeBannerApi: apiContentManagement.HomeBannerApi
  homeWelcomeApi: apiContentManagement.HomeWelcomeApi
  homeCertificationAgencyApi: apiContentManagement.HomeCertificationAgencyApi
  homeNewsApi: apiContentManagement.HomeNewsApi

  // Content Management - Gallery
  galleryApi: apiContentManagement.GalleryApi

  // Content Management - TUK
  contentTukApi: apiContentManagement.TukApi

  // Content Management - Certification
  certificationSchemaApi: apiContentManagement.CertificationSchemaApi
  certificationRequirementApi: apiContentManagement.CertificationRequirementApi
  certificationProcessApi: apiContentManagement.CertificationProcessApi
  certificationProcedureApi: apiContentManagement.CertificationProcedureApi
  certificationParticipatedIndustriesApi: apiContentManagement.CertificationParticipatedIndustriesApi

  // Content Management - About Us
  aboutUsDutyApi: apiContentManagement.AboutUsDutyApi
  aboutUsProfileApi: apiContentManagement.AboutUsProfileApi
  aboutUsMottoApi: apiContentManagement.AboutUsMottoApi
  aboutUsVisionApi: apiContentManagement.AboutUsVisionApi
  aboutUsMissionApi: apiContentManagement.AboutUsMissionApi
  aboutUsWorkCultureApi: apiContentManagement.AboutUsWorkCultureApi
  aboutUsFounderApi: apiContentManagement.AboutUsFounderApi
  aboutUsStructureApi: apiContentManagement.AboutUsStructureApi
  aboutUsAuthorityApi: apiContentManagement.AboutUsAuthorityApi
  aboutUsTransformationApi: apiContentManagement.AboutUsTransformationApi

  // Content Management - Contact Us
  contactUsApi: apiContentManagement.ContactUsApi

  // Set Self Assessment Form
  setSelfAssessmentFormApi: apiSetSelfAssessmentForm.SetSelfAssessmentFormApi

  // Assessment
  assessmentApi: apiAssessment.AssessmentApi
  assessmentSupportDocumentApi: apiAssessment.AssessmentSupportDocumentApi
  assessmentAnotherDocumentApi: apiAssessment.AssessmentAnotherDocumentApi

  // Assessment - Registration
  assessmentGeneralProofApi: apiAssessment.AssessmentGeneralProofApi
  assessmentRelevantProofApi: apiAssessment.AssessmentRelevantProofApi
  assessmentCompetencyUnitApi: apiAssessment.AssessmentCompetencyUnitApi
  assessmentAdministrativeProofApi: apiAssessment.AssessmentAdministrativeProofApi


  // Assessment - Planning
  assessmentPlanningApi: apiAssessment.AssessmentPlanningApi

  // Assessment - Preparation
  assessmentPreparationApi: apiAssessment.AssessmentPreparationApi
  assessmentPreparationCommentApi: apiAssessment.AssessmentPreparationCommentApi

  constructor() {
    // Auth
    this.authApi = new apiAuth.AuthApi()

    // OTP
    this.otpApi = new apiOtp.OtpApi()

    // Webpage
    this.homeWebpageApi = new apiWebpage.HomeWebpageApi()
    this.aboutUsWebpageApi = new apiWebpage.AboutUsWebpageApi()
    this.assessorWebpageApi = new apiWebpage.AssessorWebpageApi()
    this.tukWebpageApi = new apiWebpage.TukWebpageApi()
    this.galleryWebpageApi = new apiWebpage.GalleryWebpageApi()
    this.contactUsWebpageApi = new apiWebpage.ContactUsWebpageApi()
    this.newsWebpageApi = new apiWebpage.NewsWebpageApi()

    // Webpage - Certification
    this.certificationWebpageApi = new apiWebpage.CertificationWebpageApi()

    // Webpage - Certification - Registration
    this.certificationWebpageProcessDateApi = new apiWebpage.CertificationWebpageProcessDateApi()
    this.certificationWebpagePersonalDataApi = new apiWebpage.CertificationWebpagePersonalDataApi()
    this.certificationWebpageGeneralProofApi = new apiWebpage.CertificationWebpageGeneralProofApi()
    this.certificationWebpageRelevantProofApi = new apiWebpage.CertificationWebpageRelevantProofApi()
    this.certificationWebpageSupportDocumentApi = new apiWebpage.CertificationWebpageSupportDocumentApi()
    this.certificationWebpagePurposeOfAssessmentApi = new apiWebpage.CertificationWebpagePurposeOfAssessmentApi()
    this.certificationWebpageSelfAssessmentApi = new apiWebpage.CertificationSelfAssessmentWebpageApi()
    this.certificationWebpageFinalApi = new apiWebpage.CertificationWebpageFinalApi()

    // Master
    this.masterBranchApi = new apiMaster.BranchApi()
    this.masterCompanyApi = new apiMaster.CompanyApi()
    this.masterDocumentDetailApi = new apiMaster.DocumentDetailApi()
    this.masterDocumentProofApi = new apiMaster.DocumentProofApi()
    this.masterRoleApi = new apiMaster.RoleApi()
    this.masterFieldApi = new apiMaster.FieldApi()
    this.masterCertificationSchemaApi = new apiMaster.CertificationSchemaApi()

    // Personal Data
    this.profileApi = new apiPersonalData.ProfileApi()
    this.myDocumentApi = new apiPersonalData.MyDocumentApi()
    this.additionalQuestionApi = new apiPersonalData.AdditionalQuestionAPI()

    // User Management
    this.userApi = new apiUser.UserApi()

    // User Access
    this.userAccessApi = new apiUserAccess.UserAccessApi()

    // QnA
    this.qaApi = new apiQa.QaApi()

    // Content Management - Home
    this.homeBannerApi = new apiContentManagement.HomeBannerApi()
    this.homeWelcomeApi = new apiContentManagement.HomeWelcomeApi()
    this.homeCertificationAgencyApi = new apiContentManagement.HomeCertificationAgencyApi()
    this.homeNewsApi = new apiContentManagement.HomeNewsApi()

    // Content Management - Gallery
    this.galleryApi = new apiContentManagement.GalleryApi()

    // Content Management - TUK
    this.contentTukApi = new apiContentManagement.TukApi()

    // Content Management - Certification
    this.certificationSchemaApi = new apiContentManagement.CertificationSchemaApi()
    this.certificationRequirementApi = new apiContentManagement.CertificationRequirementApi()
    this.certificationProcessApi = new apiContentManagement.CertificationProcessApi()
    this.certificationProcedureApi = new apiContentManagement.CertificationProcedureApi()
    this.certificationParticipatedIndustriesApi = new apiContentManagement.CertificationParticipatedIndustriesApi()

    // Content Management - About Us
    this.aboutUsProfileApi = new apiContentManagement.AboutUsProfileApi()
    this.aboutUsDutyApi = new apiContentManagement.AboutUsDutyApi()
    this.aboutUsMottoApi = new apiContentManagement.AboutUsMottoApi()
    this.aboutUsVisionApi = new apiContentManagement.AboutUsVisionApi()
    this.aboutUsMissionApi = new apiContentManagement.AboutUsMissionApi()
    this.aboutUsWorkCultureApi = new apiContentManagement.AboutUsWorkCultureApi()
    this.aboutUsFounderApi = new apiContentManagement.AboutUsFounderApi()
    this.aboutUsStructureApi = new apiContentManagement.AboutUsStructureApi()
    this.aboutUsAuthorityApi = new apiContentManagement.AboutUsAuthorityApi()
    this.aboutUsTransformationApi = new apiContentManagement.AboutUsTransformationApi()

    // Content Management - Contact Us
    this.contactUsApi = new apiContentManagement.ContactUsApi()

    // Set Self Assessment Form
    this.setSelfAssessmentFormApi = new apiSetSelfAssessmentForm.SetSelfAssessmentFormApi()

    // Assessment
    this.assessmentApi = new apiAssessment.AssessmentApi()
    this.assessmentSupportDocumentApi = new apiAssessment.AssessmentSupportDocumentApi()
    this.assessmentAnotherDocumentApi = new apiAssessment.AssessmentAnotherDocumentApi()

    // Assessment - Registration
    this.assessmentGeneralProofApi = new apiAssessment.AssessmentGeneralProofApi()
    this.assessmentRelevantProofApi = new apiAssessment.AssessmentRelevantProofApi()
    this.assessmentCompetencyUnitApi = new apiAssessment.AssessmentCompetencyUnitApi()
    this.assessmentAdministrativeProofApi = new apiAssessment.AssessmentAdministrativeProofApi()

    // Assessment - Planning
    this.assessmentPlanningApi = new apiAssessment.AssessmentPlanningApi()

    // Assessment - Preparation
    this.assessmentPreparationApi = new apiAssessment.AssessmentPreparationApi()
    this.assessmentPreparationCommentApi = new apiAssessment.AssessmentPreparationCommentApi()
  }
}
